import { BaseState, Filter, INITIAL_BASE_STATE, Pagination } from '@iot-platform/models/common';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { DeviceVariablesActions } from '../actions';
import { DeviceVariable } from '@iot-platform/models/i4b';

export type State = BaseState<DeviceVariable, Pagination, Filter>;

export const adapter: EntityAdapter<DeviceVariable> = createEntityAdapter<DeviceVariable>({
  selectId: (entity: DeviceVariable) => entity.id,
  sortComparer: false
});

export const initialState: State = adapter.getInitialState({
  ...INITIAL_BASE_STATE,
  pagination: { currentPage: 0, hasMore: false, limit: 1000, maxPage: 0, total: 0 }
});

export const deviceVariablesFeature = createFeature({
  name: 'deviceVariables',
  reducer: createReducer(
    initialState,
    on(DeviceVariablesActions.loadDeviceVariables, (state: State): State => ({ ...state, loading: true, loaded: false })),
    on(
      DeviceVariablesActions.loadDeviceVariablesSuccess,
      (state: State, { response }): State => adapter.setAll(response, { ...state, loaded: true, loading: false })
    ),
    on(DeviceVariablesActions.loadDeviceVariablesFailure, (state: State): State => ({ ...state, loaded: false, loading: false }))
  )
});
